import { render, staticRenderFns } from "./AddItems.vue?vue&type=template&id=6f20204e&scoped=true"
import script from "./AddItems.vue?vue&type=script&lang=js"
export * from "./AddItems.vue?vue&type=script&lang=js"
import style0 from "./AddItems.vue?vue&type=style&index=0&id=6f20204e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20204e",
  null
  
)

export default component.exports